export default "__VITE_ASSET__Db5zr5c5__"